import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useBoolean from '../../../Utils/useBoolean';
import {Drawer, Form, Button, Input, message, InputNumber, Popconfirm} from 'antd';
import { EditFilled } from '@ant-design/icons';
import b_ from 'b_';
import splitArray from '../../../Utils/splitArray';
import { groupChangeProxies } from '../../../Reducers/proxies';
// import { changeRatios } from '../../../Reducers/resell';

const GroupEnablingButtonGroup = ({
                     afterUpdate,
                     selected,
                     payload
                   }) => {

  const b = b_.lock('DisableButton');

  const dispatch = useDispatch();

  const handleSuccess = useCallback((data) => {

    if (selected.length) {
      const newArr = selected.map((el) => el.split(','))
      const preparedArr = splitArray(newArr)

      const handleData = payload.map((item) => {
        return {...item, ...data}
      })

      dispatch(groupChangeProxies(handleData))
      .then(() => {
        message.success('Proxies has been changed!');
        afterUpdate();
      }).catch((error) => {
        // console.log(error);
        message.error('Can\'t update proxies.');
      });
    }
  }, [dispatch, afterUpdate, selected]);
  
  return (
    <div style={{marginRight: '16px'}}>
      <Popconfirm
          title={`Are you sure to enable ${selected.length} ${selected.length === 1 ? 'product' : 'products'}?`}
          onConfirm={() => handleSuccess({'status': "Enabled"})}
          okText="Yes"
          cancelText="No"
        >
      <Button
        type="primary"
        disabled={!selected.length}
        style={{marginRight: '16px'}}
      >
        Enable
      </Button>
      </Popconfirm>
    <Popconfirm
          title={`Are you sure to disable ${selected.length} ${selected.length === 1 ? 'product' : 'products'}?`}
          onConfirm={() => handleSuccess({'status': "Disabled"})}
          okText="Yes"
          cancelText="No"
        >
      <Button
        type="primary"
        disabled={!selected.length}
      >
        Disable
      </Button>
      </Popconfirm>
    </div>
  );
};

export default React.memo(GroupEnablingButtonGroup);
